import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import useBrowserHistoryStore from "../../store/useBrowserHistoryStore";

export default function BrowserHistoryContainer() {
  const { add } = useBrowserHistoryStore();
  const location = useLocation();

  useEffect(() => {
    add(location.pathname);
  }, [location.pathname]);

  return <Outlet />;
}
